export default __webpack_public_path__ + "static/media/property_568.6b064157.png";